import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import ReactTooltip from "react-tooltip";

class TableBody extends Component {
  renderCell = (item, column, index) => {
    if (column.content) return column.content(item, index);
    if (column.path.indexOf("date") >= 0)
      return _.get(item, column.path)
        ? moment(_.get(item, column.path)).format("DD-MM-YYYY")
        : "-";

    return _.get(item, column.path);
  };

  createKey = (item, column) => {
    return item._id + (column.path || column.key);
  };
  getClasses = item => {
    let classes = "";
    if (item.error) classes = "danger";
    return classes;
  };
  render() {
    const { data, columns, keyId } = this.props;
    return (
      <tbody>
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <tr
              className={this.getClasses(item)}
              key={item._id || index + item[keyId]}
            >
              {columns.map(column => (
                <React.Fragment key={this.createKey(item, column)}>
                  {!item.hidden && (
                    <td
                      style={{
                        textAlign: column.textAlign ? column.textAlign : "left"
                      }}
                    >
                      {this.renderCell(item, column, index)}
                    </td>
                  )}
                </React.Fragment>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <th colSpan="99" style={{ textAlign: "center" }}>
              No Data
            </th>
          </tr>
        )}
      </tbody>
    );
  }
}

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/Common/tableBody.jsx